import { SVGProps } from 'react';

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 18 18"
    {...props}
  >
    <path
      fill="#686D7E"
      d="M8.993 1.5C4.853 1.5 1.5 4.86 1.5 9s3.353 7.5 7.493 7.5c4.147 0 7.507-3.36 7.507-7.5s-3.36-7.5-7.507-7.5M9 15c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6"
    ></path>
    <path
      stroke="#686D7E"
      strokeLinecap="square"
      strokeLinejoin="round"
      strokeWidth="2"
      d="m13.5 4.5-9 9"
    ></path>
  </svg>
);

export default SvgIcon;
